import axios from "axios";

export const API_URL = ''

export const doPostPublic = async (url, data) => {
    return await axios.post(`${API_URL}${url}`, data)
}

export const doPost = async (url, data) => {
    return await axios.post(`${API_URL}${url}`, data)
}

export const doPut = async (url, data) => {
    return await axios.put(`${API_URL}${url}`, data)
}
export const doDelete = async (url, data) => {
    return await axios.delete(`${API_URL}${url}`, data)
}

export const doPatch = async (url, data) => {
    return await axios.patch(`${API_URL}${url}`, data)
};

export const doGet = async (url, query, headers) => {
    const queryParams = query ?  new URLSearchParams(query).toString() : ''
    const queryUrl = queryParams ? `?${queryParams}` : ''

    if (headers){
        return await axios.get(`${API_URL}${url}${queryUrl}`, {
            headers: headers,
        })
    }
    return await axios.get(`${API_URL}${url}${queryUrl}`, {})

};

export const doGetDownload = async (url, query) => {
    const queryParams = new URLSearchParams(query).toString()
    const queryUrl = queryParams ? `?${queryParams}` : ''

    return await axios.get(`${API_URL}${url}${queryUrl}`, {
        headers: {
            'Accept': '*/*'
        },
        responseType: 'arraybuffer'
    })

};

export const doUpload = async (url, formData, onUploadProgress) => {
    return await axios.post(`${API_URL}${url}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: onUploadProgress
    });
};

export const doUploadRemote = async (url, formData, onUploadProgress, token) => {
    const accessToken = "Bearer " + token;
    axios.defaults.headers.common["Authorization"] = accessToken

    return await axios.post(`${API_URL}${url}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': accessToken,
        },
        onUploadProgress: onUploadProgress
    });
};
